import { Check, workDef } from './check.class';
import { merge } from 'lodash';

export class CheckElec extends Check {
  data: {
    alim400VXJDB1: {
      R_S?: number;
      R_T?: number;
      S_T?: number;
    },
    alim400VXJDB2: {
      R_S?: number;
      R_T?: number;
      S_T?: number;
    },
    alim230V: {
      N_R?: number;
      N_S?: number;
      N_T?: number;
    },
    works: any;
    comments?: string;
  };

  constructor(obj?: any) {
    super(CheckElec.type);

    if(!obj) obj = {};

    this.data = merge({
        alim400VXJDB1: {},
        alim400VXJDB2: {},
        alim230V: {},
        works: CheckElec.getEmptyWorks(),
        comments: '',
      },
      obj.data,
    );
  }

  public static type = 'elec';
  public static label = 'Organes électriques et automatismes';

  public static getEmptyWorks() {
    let works = {};
    this.listWorks.forEach((workDef) => {
      works[workDef.field] = {
        done: null,
        comment: '',
      };
      if (workDef.subFields) {
        workDef.subFields.forEach((subField) => {
          works[workDef.field][subField.field] = null;
        })
      }
    });
    return works;
  }

  public static listWorks: Array<workDef> = [
    {
      label: 'Eclairage local',
      field: 'localLight',
      checker: true,
      comment: true,
    }, {
      label: 'Eclairage armoire',
      field: 'cabinetLight',
      checker: true,
      comment: true,
    }, {
      label: 'Eclairage post',
      field: 'posteLight',
      checker: true,
      comment: true,
    }, {
      label: 'Nettoyage armoire',
      field: 'cabinetClean',
      checker: true,
      comment: true,
    }, {
      label: 'Serrage des bornes et cosses',
      field: 'terminalsClamping',
      checker: true,
      comment: true,
    }, {
      label: 'Vérification et réglages calibre des protections',
      field: 'protectionsCaliberCheck',
      checker: true,
      comment: true,
    }, {
      label: 'Vérification des tensions Amont/Aval protections',
      field: 'protectionsTensionCheck',
      checker: true,
      comment: true,
    }, {
      label: 'Test différentiels',
      field: 'testDiff',
      checker: true,
      comment: true,
      subFields: [{label: 'Valeur', field: 'value', unit: 'mA', type: 'number'}],
    }, {
      label: 'Essais Voltmètre',
      field: 'tensionTries',
      checker: true,
      comment: true,
    }, {
      label: 'Relais tension',
      field: 'tensionRelay',
      checker: true,
      comment: true,
    }, {
      label: 'Circuit Puissance',
      field: 'powerCircuit',
      checker: false,
      comment: true,
      subFields: [{label: 'Tension', field: 'tension', unit: 'Vac', type: 'number'}],
    }, {
      label: 'Circuit Commande',
      field: 'commandCircuit',
      checker: false,
      comment: true,
      subFields: [{label: 'Tension', field: 'tension', unit: 'Vac', type: 'number'}],
    }, {
      label: 'Circuit Signalisation',
      field: 'signalisationCircuit',
      checker: false,
      comment: true,
      subFields: [{label: 'Tension', field: 'tension', unit: 'Vac', type: 'number'}],
    }, {
      label: 'Déclenchement des Arrêt d\'Urgence',
      field: 'emergencyStopTrigger',
      checker: true,
      comment: true,
    }, {
      label: 'Chauffage armoire',
      field: 'cabinetWarming',
      checker: true,
      comment: true,
    }, {
      label: 'Thermostat chauffage armoire',
      field: 'cabinetThermostat',
      checker: false,
      comment: true,
      subFields: [{label: 'Temp.', field: 'temperature', unit: '°C', type: 'number'}],
    }, {
      label: 'Fonctionnement Manuel',
      field: 'manualUse',
      checker: true,
      comment: true,
    }, {
      label: 'Vérification automate/télétransmetteur',
      field: 'automatonCheck',
      checker: true,
      comment: true,
    }, {
      label: 'Gestion des niveaux',
      field: 'levelManagement',
      checker: false,
      comment: true,
      subFields: [
        {label: 'Marche', field: 'run', unit: 'cm', type: 'number'},
        {label: 'Arret', field: 'stop', unit: 'cm', type: 'number'},
      ],
    },
  ];
}



// WEBPACK FOOTER //
// ./src/app/models/check/check-elec.class.ts